import applications from "./applications";
import assessmentPlaceApplications from "./assessmentPlaceApplications";
import rawMaterialCompleteStatuses from "./rawMaterialCompleteStatuses";
import inspectionHistories from "./inspectionHistories";
import testItems from "../setting/testItems";

const applicationService = [
    {
        matcher: 'applications',
        reply: config => {
            return [200, applications];
        }
    },
    {
        matcher: /applications\/(.*)/,
        reply: config => {
            const no = /applications\/(.*)/.exec(config.url)[1];
            const application = applications.find(application => application.no === no);
            return [200, application];
        }
    },
    {
        matcher: /assessmentPlaceApplications\/(.*)/,
        reply: config => {
            const no = /assessmentPlaceApplications\/(.*)/.exec(config.url)[1];
            const application = assessmentPlaceApplications.find(application => application.no === no);
            return [200, application];
        }
    },
    {
        matcher: /rawMaterialCompleteStatuses\/(.*)/,
        reply: config => {
            const no = /rawMaterialCompleteStatuses\/(.*)/.exec(config.url)[1];
            const application = rawMaterialCompleteStatuses.find(application => application.no === no);
            return [200, application];
        }
    },
    {
        matcher:/assessmentPlaces\/(.*)\/inspectionHistories/,
        reply: config => {
            return [200, inspectionHistories];
        }
    }
]

export default  applicationService